const privacyPolicy = [
    { 
        id: "overview", 
        title: "1. Overview", 
        content: "Welcome to QuickRide Car Rentals! Your privacy is important to us. This policy outlines how we collect, use, and protect your personal data when you rent a vehicle from us."
    },
    { 
        id: "data-privacy", 
        title: "2. Data Privacy", 
        content: "We collect personal data to process your rentals and enhance your experience. This includes:",
        list: [
            "Customer registration details (name, contact information, driver's license)",
            "Booking history and rental preferences",
            "Payment and billing details",
            "Location and vehicle tracking (where applicable)"
        ]
    },
    { 
        id: "terms-of-service", 
        title: "3. Terms of Service", 
        content: "By using our rental services, you agree to abide by our terms, including responsible vehicle usage, return conditions, and payment obligations."
    },
    { 
        id: "user-rights", 
        title: "4. User Rights", 
        content: "As a customer, you have the following rights regarding your data:",
        list: [
            "Right to access and update your personal details",
            "Right to request deletion of your data",
            "Right to withdraw consent for marketing communications"
        ]
    },
    { 
        id: "data-security", 
        title: "5. Data Security", 
        content: "We implement secure encryption and access controls to protect your data from unauthorized access, fraud, and misuse."
    },
    { 
        id: "cookies", 
        title: "6. Cookies", 
        content: "Our website uses cookies to improve functionality and personalize your experience. You can manage cookie preferences through your browser settings."
    },
    { 
        id: "third-party", 
        title: "7. Third-Party Services", 
        content: "We may share data with third-party providers for payment processing, insurance, and roadside assistance. We ensure these partners adhere to strict privacy standards."
    },
    { 
        id: "data-storage", 
        title: "8. Data Storage", 
        content: "Your data is securely stored for the duration of our business relationship. Retention periods may vary based on legal and operational requirements."
    },
    { 
        id: "data-transfers", 
        title: "9. Data Transfers", 
        content: "If necessary, your data may be transferred to international data centers. We ensure compliance with applicable data protection regulations."
    },
    { 
        id: "policy-updates", 
        title: "10. Policy Updates", 
        content: "We may update this privacy policy periodically. Any significant changes will be communicated via email or posted on our website."
    }
];

export default privacyPolicy;